/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  TableViewCreateAPIDataRequest
} from '../../model/tableViewCreateAPIDataRequest'
import type {
  TableViewReadData
} from '../../model/tableViewReadData'
import type {
  TableViewReadDataList
} from '../../model/tableViewReadDataList'
import type {
  TableViewUpdateAPIDataRequest
} from '../../model/tableViewUpdateAPIDataRequest'
import { axiosRequest } from '../../../shared/api/Api';


      
type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];



      import { appQueryClient } from "app/AppQueryClient";
      import { LoaderFunction, Params } from "@remix-run/router";
      import { isLoggedIn } from "axios-jwt";

      const authedLoader = (loader: LoaderFunction): LoaderFunction =>
        async (args) => {
          const result = await isLoggedIn();
          if (result) {
            return loader(args);
          }
          return null;
        };
    /**
 * List all table views visible to the user
 */
export const tableViewsGet = (
    
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<TableViewReadDataList>(
      {url: `/table-views`, method: 'GET', signal
    },
      options);
    }
  

export const getTableViewsGetQueryKey = () => {
    return [`/table-views`] as const;
    }

    
export const getTableViewsGetQueryOptions = <TData = Awaited<ReturnType<typeof tableViewsGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tableViewsGet>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTableViewsGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof tableViewsGet>>> = ({ signal }) => tableViewsGet(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tableViewsGet>>, TError, TData> & { queryKey: QueryKey }
}

export type TableViewsGetQueryResult = NonNullable<Awaited<ReturnType<typeof tableViewsGet>>>
export type TableViewsGetQueryError = unknown

export const useTableViewsGet = <TData = Awaited<ReturnType<typeof tableViewsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tableViewsGet>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getTableViewsGetQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getTableViewsGetSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof tableViewsGet>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof tableViewsGet>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTableViewsGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof tableViewsGet>>> = ({ signal }) => tableViewsGet(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof tableViewsGet>>, TError, TData> & { queryKey: QueryKey }
}

export type TableViewsGetSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof tableViewsGet>>>
export type TableViewsGetSuspenseQueryError = unknown

export const useTableViewsGetSuspense = <TData = Awaited<ReturnType<typeof tableViewsGet>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof tableViewsGet>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getTableViewsGetSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getTableViewsGetLoader = (): LoaderFunction =>
        authedLoader(() => appQueryClient.prefetchQuery({
          queryKey: getTableViewsGetQueryKey(),
          queryFn: () => tableViewsGet(),
        }).then(() => null));
      /**
 * Create a new view
 */
export const tableViewCreate = (
    tableViewCreateAPIDataRequest: TableViewCreateAPIDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<TableViewReadData>(
      {url: `/table-views`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tableViewCreateAPIDataRequest
    },
      options);
    }
  


export const getTableViewCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tableViewCreate>>, TError,{data: TableViewCreateAPIDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof tableViewCreate>>, TError,{data: TableViewCreateAPIDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tableViewCreate>>, {data: TableViewCreateAPIDataRequest}> = (props) => {
          const {data} = props ?? {};

          return  tableViewCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TableViewCreateMutationResult = NonNullable<Awaited<ReturnType<typeof tableViewCreate>>>
    export type TableViewCreateMutationBody = TableViewCreateAPIDataRequest
    export type TableViewCreateMutationError = unknown

    export const useTableViewCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tableViewCreate>>, TError,{data: TableViewCreateAPIDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getTableViewCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Returns all details about a given table view
 */
export const tableViewGet = (
    viewId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<TableViewReadData>(
      {url: `/table-views/${viewId}`, method: 'GET', signal
    },
      options);
    }
  

export const getTableViewGetQueryKey = (viewId: string,) => {
    return [`/table-views/${viewId}`] as const;
    }

    
export const getTableViewGetQueryOptions = <TData = Awaited<ReturnType<typeof tableViewGet>>, TError = unknown>(viewId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tableViewGet>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTableViewGetQueryKey(viewId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof tableViewGet>>> = ({ signal }) => tableViewGet(viewId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(viewId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tableViewGet>>, TError, TData> & { queryKey: QueryKey }
}

export type TableViewGetQueryResult = NonNullable<Awaited<ReturnType<typeof tableViewGet>>>
export type TableViewGetQueryError = unknown

export const useTableViewGet = <TData = Awaited<ReturnType<typeof tableViewGet>>, TError = unknown>(
 viewId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tableViewGet>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getTableViewGetQueryOptions(viewId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getTableViewGetSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof tableViewGet>>, TError = unknown>(viewId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof tableViewGet>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTableViewGetQueryKey(viewId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof tableViewGet>>> = ({ signal }) => tableViewGet(viewId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(viewId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof tableViewGet>>, TError, TData> & { queryKey: QueryKey }
}

export type TableViewGetSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof tableViewGet>>>
export type TableViewGetSuspenseQueryError = unknown

export const useTableViewGetSuspense = <TData = Awaited<ReturnType<typeof tableViewGet>>, TError = unknown>(
 viewId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof tableViewGet>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getTableViewGetSuspenseQueryOptions(viewId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getTableViewGetLoader = (paramsOrFn?: (Params | ((params: Params) => ({ viewId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { viewId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (viewId) {
            return appQueryClient.prefetchQuery({
              queryKey: getTableViewGetQueryKey(viewId),
              queryFn: () => tableViewGet(viewId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Update a table view
 */
export const tableViewUpdate = (
    viewId: string,
    tableViewUpdateAPIDataRequest: TableViewUpdateAPIDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<TableViewReadData>(
      {url: `/table-views/${viewId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: tableViewUpdateAPIDataRequest
    },
      options);
    }
  


export const getTableViewUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tableViewUpdate>>, TError,{viewId: string;data: TableViewUpdateAPIDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof tableViewUpdate>>, TError,{viewId: string;data: TableViewUpdateAPIDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tableViewUpdate>>, {viewId: string;data: TableViewUpdateAPIDataRequest}> = (props) => {
          const {viewId,data} = props ?? {};

          return  tableViewUpdate(viewId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TableViewUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof tableViewUpdate>>>
    export type TableViewUpdateMutationBody = TableViewUpdateAPIDataRequest
    export type TableViewUpdateMutationError = unknown

    export const useTableViewUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tableViewUpdate>>, TError,{viewId: string;data: TableViewUpdateAPIDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getTableViewUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Delete a given table view
 */
export const tableViewDelete = (
    viewId: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/table-views/${viewId}`, method: 'DELETE'
    },
      options);
    }
  


export const getTableViewDeleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tableViewDelete>>, TError,{viewId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof tableViewDelete>>, TError,{viewId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tableViewDelete>>, {viewId: string}> = (props) => {
          const {viewId} = props ?? {};

          return  tableViewDelete(viewId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TableViewDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof tableViewDelete>>>
    
    export type TableViewDeleteMutationError = unknown

    export const useTableViewDelete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tableViewDelete>>, TError,{viewId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getTableViewDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    